import { requester } from '../utils';

export const getUserProfile = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/user/profile`,
        method: 'GET',
        withAuth: true,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('get user info error', err);
        reject(err);
      });
  });
};

export const editUserProfile = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/user/profile`,
        method: 'PUT',
        withAuth: true,
        data
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('edit user info error', err);
        reject(err);
      });
  });
};